import { DatePipe, DecimalPipe, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { EspecieEppoPopupComponent } from '../../../core/components/popup/especies/especieEppoPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc, WBotanicaExtendedViewModel, TcPerfilUsuarioEnum, EnumIdsTcPais } from '../../../core/_infrastructure/types/common';
import { PartidaPreduaPopupComponent } from '../components/popup/partidaPredua/partidaPreduaPopup.component';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { PreduaService } from '../predua/predua.service';
import { PartidaPreduaItemResultViewModel, TPartidaPreduaViewModel, TPreduaViewModel } from '../predua/predua.types';
import {
    EnumCodigosTwTcAcciones,
    EnumIdsTcEstadoSolicitud,
    EnumIdsTcGrupo,
    EnumIdsTcSubTipoSolicitud,
    EnumIdsTcTipoSolicitud,
    EnumIdsTwTcTipoClonacion,
} from '../types/enum';
import { ProductosService } from './productos.service';
import { SolicitudProductosViewModel, TProductoSolicitudViewModel, ComprobarCompatibleViewModel } from './productos.types';
import { HttpParams } from '@angular/common/http';
import { Subject, catchError, combineLatest, map, of, tap } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { FormaViewModel } from '../../../_mantenimiento/especies/gruposformas/grupoforma.types';

@Component({
    selector: 'app-productos-edit',
    templateUrl: './productos-edit.component.html',
})
export class ProductoEditComponent extends ComponentBase implements OnInit {
    @ViewChild(PartidaPreduaPopupComponent)
    private partidaPreduaPopupComponent: PartidaPreduaPopupComponent;
    @ViewChild(EspecieEppoPopupComponent)
    private especieEppoPopupComponent: EspecieEppoPopupComponent;

    private editMode = false;
    editTitle = 'Nuevo';
    isCanariasPifCanarias = false;
    esPredua = false;
    private esProdFitoObservable$: Subject<boolean>;
    private gruposLoaded$: Subject<boolean>;

    codigoSolicitud: string;
    tituloTipoSolicitud: string;
    tituloEstadoSolicitud: string;

    IdEstadoSolicitud: number;
    IdResultadoEnvioMuestrasLaboratorio: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    campoObligatorio = true;
    campoDeclaracionSumaria = true;
    private esPasajeros = false;
    //tieneDocCoi = false; //RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
    IdTipoSolicitud: number;
    esPaisCE = false;

    listPais: Tc[];
    listPaisUe: Tc[];
    listGrupo: Tc[];
    listForma: FormaViewModel[];
    listBulto: Tc[];

    private predua: TPreduaViewModel;
    private partidas: PartidaPreduaItemResultViewModel;
    //infoPaisPartidaPredua: string = "";
    private IdPaisOrigen: number;
    private IdEspecie: number;
    private IdForma = 0;

    private IdSolicitud: number;
    private IdProducto: number;

    public producto: TProductoSolicitudViewModel;

    habilitarGuardar = true;
    private habilitarEdicion = true;
    habilitarBusquedaEppo = false;
    visibilitySpinner = false;
    esClonada = false;
    eppoObligatorio = true;
    numDecSumReadOnly = true;
    private laHeGrabadoYo = false;

    isCollapsedDatosBasicos = false;
    isCollapsedBulto = false;
    messageProductoFitosanitarioLimit =
        'Las solicitudes con productos del grupo "Productos Fitosanitarios", están limitadas a un único producto o partida para ir por la vía del "No Procede" en la Decisión';
    productoFitosanitarioFound = false;

    numeroProductos: number;
    incompatible: boolean;
    datosCompatibles: ComprobarCompatibleViewModel;

    constructor(
        public datepipe: DatePipe,
        public decimalPipe: DecimalPipe,
        private activatedRoute: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private confirmationService: ConfirmationService,
        private solicitudService: SolicitudService,
        private productoService: ProductosService,
        private preduaService: PreduaService,
        private _location: Location,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.producto = new TProductoSolicitudViewModel();
        this.datosCompatibles = new ComprobarCompatibleViewModel();
    }

    ngOnInit() {
        this.esProdFitoObservable$ = new Subject();
        this.gruposLoaded$ = new Subject();
        this.loadLists();

        this.createForm();

        // @author: scalero - Lo intentamos así, porque puede ocurrir que los datos producto-solicitud, carguen antes que la lista del grupo.
        combineLatest([this.esProdFitoObservable$, this.gruposLoaded$])
            .pipe(
                map(([esProdFito, gruposLoaded]) => {
                    if (!esProdFito && gruposLoaded) {
                        // Eliminamos el grupo "Productos Fitosanitarios" del desplegable.
                        this.removeElementFromGroup(EnumIdsTcGrupo.ID_PRODUCTOS_FITOSANITARIOS);
                    }
                    if (esProdFito && gruposLoaded) {
                        // Dejamos solo una opción con el grupo "Productos Fitosanitarios", en el desplegable.
                        this.removeElementFromGroup(EnumIdsTcGrupo.ID_PRODUCTOS_FITOSANITARIOS, true);
                    }
                    return {};
                }),
            )
            .subscribe();

        this.IdSolicitud = +this.activatedRoute.snapshot.params['id'];
        this.IdProducto = +this.activatedRoute.snapshot.params['idprod'];

        //Para que se abran las pestañas de la solicitud
        this.guardRefreshPage(this.IdSolicitud);

        if (this.IdProducto) {
            this.manageEdicionDeProducto();
        } else {
            this.manageAltaDeProducto();
        }

        //Contenedores, abrimos solo el primero
        this.isCollapsedDatosBasicos = false;
        this.isCollapsedBulto = false;
    }

    private loadLists(): void {
        this.globalService.getAllPaises().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getPaisesUe().subscribe(res => {
            this.listPaisUe = res;
        });
        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
            this.gruposLoaded$.next(true);
        });
        this.globalService.getTipoBultos().subscribe(res => {
            this.listBulto = res;
        });
    }

    private manageEdicionDeProducto(): void {
        this.editMode = true;
        this.editTitle = 'Editar';

        //Para saber si se actua como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitud', this.IdSolicitud.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());

        this.solicitudService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
            this.laHeGrabadoYo = resultIsGrabada;
            this.loadProductoById();
        });
    }

    private loadProductoById(): void {
        this.productoService.getProducto(this.IdProducto).subscribe(result => {
            this.producto = result;

            this.globalService.getFormasByGrupo(this.producto.IdGrupo).subscribe(res => {
                this.listForma = res;
            });

            this.esPredua =
                this.producto.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_NORMAL_PREDUA ||
                this.producto.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA ||
                this.producto.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA_CF ||
                this.producto.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRASLADO_PREDUA ||
                this.producto.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRANSITO_DIRECTO_PREDUA ||
                this.producto.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRANSBORDO_PREDUA ||
                this.producto.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_FINES_CIENTIFICOS_PREDUA
                    ? true
                    : false;

            this.IdTipoSolicitud = this.producto.IdTipoSolicitud;
            this.IdEstadoSolicitud = this.producto.IdEstadoSolicitud;
            this.codigoSolicitud = this.producto.Codigo;
            this.tituloTipoSolicitud = this.producto.IdTipoSolicitudDescripcion;
            this.tituloEstadoSolicitud = this.producto.IdEstadoSolicitudDescripcion;
            this.IdResultadoEnvioMuestrasLaboratorio = this.producto.IdResultadoEnvioMuestrasLaboratorio;
            this.DescripcionIdResultadoEnvioMuestrasLaboratorio = this.producto.DescripcionIdResultadoEnvioMuestrasLaboratorio;
            this.esClonada =
                this.producto.TwSolicitudJerarquia != null && this.producto.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            this.esPasajeros = this.producto.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PASAJEROS;

            this.isCanariasPifCanarias = this.producto.IsCanariasPifCanarias;
            if (this.isCanariasPifCanarias) {
                this.numDecSumReadOnly = false;
            }
            //RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
            //consulto si tiene Documento COI
            //this.tieneDocCoi = this.producto.TieneDocumentoCoi;
            //if (!this.tieneDocCoi) {
            //    this.form.controls['EsOrganico'].disable();
            //} else {
            //    this.form.controls['EsOrganico'].enable();
            //}

            this.IdForma = this.producto.IdForma;
            //this.habilitarBusquedaEppo = this.IdForma > 0 ? true : false;

            //Si es PREDUA
            if (this.esPredua && this.producto.Mrn != null) {
                this.addValidator('Mrn', Validators.required);
                this.addValidator('PaisPredua', Validators.required);
                this.removeValidators('IdPais');

                this.predua = new TPreduaViewModel();
                this.partidas = new PartidaPreduaItemResultViewModel();
                this.preduaService.getPreduaByMrn(this.producto.Mrn).subscribe(result => {
                    this.predua = result;
                    this.partidas.ResultList = this.predua.TPartidasPreduaList;
                    this.partidas.TotalCount = this.predua.TPartidasPreduaList.length;
                });
            }
            //Si NO es PREDUA
            else {
                this.addValidator('NumeroDeclaracionSumaria', Validators.required);
                this.addValidator('IdPais', Validators.required);
                this.removeValidators('PaisPredua');
                this.removeValidators('Partida');
            }

            this.updateForm();
            this.esPaisCE = this.producto.IdPais == EnumIdsTcPais.ID_COMUNIDAD_EUROPEA ? true : false;
            if (this.esPaisCE) {
                this.addValidator('IdPaisReImportacion', Validators.required);
            }

            //Si soy Grabador
            if (this.isGrabador && this.producto.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
                this.habilitarGuardar =
                    this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.producto.IdEstadoSolicitud).Visible && this.laHeGrabadoYo;
                this.habilitarEdicion =
                    this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.producto.IdEstadoSolicitud).Visible && this.laHeGrabadoYo;
            } else {
                this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.producto.IdEstadoSolicitud).Visible;
                this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, this.producto.IdEstadoSolicitud).Visible;
            }

            this.habilitarBusquedaEppo = this.IdForma > 0 ? this.habilitarEdicion : false;

            if (!this.habilitarEdicion) {
                //metodo para deshabilitar los controles
                this.disableControlsConsulta();
            }
            //SI ES RE-IMPORTACION
            if (this.producto.EsReImportacion) {
                this.tituloTipoSolicitud += ' - Re-Importación';
            }
            //SI ES PREVIA
            if (this.producto.EsPrevia) {
                if (
                    this.producto.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                    this.producto.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                ) {
                    this.tituloTipoSolicitud += ' - Previa';
                }
                //Si es PREVIA SIN CODIGO se eliminan validaciones
                if (this.producto.Codigo == null) {
                    this.removeValidationsPrevia();
                    this.campoObligatorio = false;
                }
            }
            //Si es solicitud pasajeros
            if (this.esPasajeros) {
                this.campoDeclaracionSumaria = false;
                this.removeValidators('NumeroDeclaracionSumaria');
            }

            this.esProdFitoObservable$.next(this.IdTipoSolicitud === EnumIdsTcTipoSolicitud.ID_PROD_FITOSANITARIOS);
        });
    }

    private manageAltaDeProducto(): void {
        this.productoService.getSolicitudProductos(this.IdSolicitud).subscribe((resultSolicitudProductos: SolicitudProductosViewModel) => {
            this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES, resultSolicitudProductos.IdEstadoSolicitud).Visible;
            if (!this.habilitarGuardar) {
                //metodo para deshabilitar los controles
                this.disableControlsConsulta();
            }

            this.esPredua =
                resultSolicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_NORMAL_PREDUA ||
                resultSolicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA ||
                resultSolicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA_CF ||
                resultSolicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRASLADO_PREDUA ||
                resultSolicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRANSITO_DIRECTO_PREDUA ||
                resultSolicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_TRANSBORDO_PREDUA ||
                resultSolicitudProductos.IdSubTipoSolicitud == EnumIdsTcSubTipoSolicitud.ID_FINES_CIENTIFICOS_PREDUA
                    ? true
                    : false;

            this.IdTipoSolicitud = resultSolicitudProductos.IdTipoSolicitud;
            this.IdEstadoSolicitud = resultSolicitudProductos.IdEstadoSolicitud;
            this.codigoSolicitud = resultSolicitudProductos.CodigoSolicitud;
            this.tituloTipoSolicitud = resultSolicitudProductos.IdTipoSolicitudDescripcion;
            this.tituloEstadoSolicitud = resultSolicitudProductos.IdEstadoSolicitudDescripcion;
            this.IdResultadoEnvioMuestrasLaboratorio = resultSolicitudProductos.IdResultadoEnvioMuestrasLaboratorio;
            this.DescripcionIdResultadoEnvioMuestrasLaboratorio = resultSolicitudProductos.DescripcionIdResultadoEnvioMuestrasLaboratorio;

            this.esClonada =
                resultSolicitudProductos.TwSolicitudJerarquia != null &&
                resultSolicitudProductos.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            this.esPasajeros = resultSolicitudProductos.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PASAJEROS;

            this.isCanariasPifCanarias = resultSolicitudProductos.IsCanariasPifCanarias;
            if (this.isCanariasPifCanarias) {
                this.numDecSumReadOnly = false;
            }
            //RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
            //consulto si tiene Documento COI
            //this.tieneDocCoi = resultSolicitudProductos.TieneDocumentoCoi;
            //if (!this.tieneDocCoi) {
            //    this.form.controls['EsOrganico'].disable();
            //} else {
            //    this.form.controls['EsOrganico'].enable();
            //}

            //Si es PREDUA, cargo los datos predua y partidas con el Mrn
            if (this.esPredua && resultSolicitudProductos.TMedioTransporte.Mrn != null) {
                this.addValidator('Mrn', Validators.required);
                this.addValidator('PaisPredua', Validators.required);
                //Cargo el Num.Declaracion Sumaria con el MRN
                this.form.patchValue({
                    Mrn: resultSolicitudProductos.TMedioTransporte.Mrn,
                });

                this.predua = new TPreduaViewModel();
                this.partidas = new PartidaPreduaItemResultViewModel();
                this.preduaService.getPreduaByMrn(resultSolicitudProductos.TMedioTransporte.Mrn).subscribe(result => {
                    this.predua = result;
                    this.partidas.ResultList = this.predua.TPartidasPreduaList;
                    this.partidas.TotalCount = this.predua.TPartidasPreduaList.length;
                });
            }

            //Si NO es PREDUA se carga la Declaración de TMedioTransporte
            else {
                //precargo el Pais de Origen de la solicitud
                if (resultSolicitudProductos.IdPais != null) {
                    this.form.patchValue({
                        IdPais: resultSolicitudProductos.IdPais,
                    });
                }

                this.esPaisCE = resultSolicitudProductos.IdPais == EnumIdsTcPais.ID_COMUNIDAD_EUROPEA ? true : false;
                if (this.esPaisCE) {
                    this.addValidator('IdPaisReImportacion', Validators.required);
                }

                this.addValidator('NumeroDeclaracionSumaria', Validators.required);
                this.addValidator('IdPais', Validators.required);
                this.removeValidators('PaisPredua');
                this.removeValidators('Partida');
                //Cargo el Num.Declaracion Sumaria
                this.form.patchValue({
                    NumeroDeclaracionSumaria: resultSolicitudProductos.TMedioTransporte.NumeroDeclaracionSumaria,
                });
            }

            //SI ES RE-IMPORTACION
            if (resultSolicitudProductos.EsReImportacion) {
                this.tituloTipoSolicitud += ' - Re-Importación';
            }
            //SI ES PREVIA
            if (resultSolicitudProductos.EsPrevia) {
                if (
                    resultSolicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                    resultSolicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                ) {
                    this.tituloTipoSolicitud += ' - Previa';
                }
                //Si es PREVIA SIN CODIGO se eliminan validaciones
                if (resultSolicitudProductos.CodigoSolicitud == null) {
                    this.removeValidationsPrevia();
                    this.campoObligatorio = false;
                }
            }
            //Si es solicitud pasajeros
            if (this.esPasajeros) {
                this.campoDeclaracionSumaria = false;
                this.removeValidators('NumeroDeclaracionSumaria');
            }

            this.esProdFitoObservable$.next(this.IdTipoSolicitud === EnumIdsTcTipoSolicitud.ID_PROD_FITOSANITARIOS);
        });
    }

    /**
     * Las peticiones de tipo 'Productos Fitosanitarios', solo podrán usar el grupo de producto 'Productos Fitosanitarios'.
     * Para el resto de solicitudes, éste grupo no estará disponible, de ahí que se elimine de la lista.
     */
    private removeElementFromGroup(idGrupo: number, unique = false) {
        const index = this.listGrupo?.findIndex(x => x.Id === idGrupo);

        if (index > -1) {
            const grupoUnico = this.listGrupo.splice(index, 1);
            if (!unique) {
                this.listGrupo = [...this.listGrupo];
            } else {
                this.listGrupo = grupoUnico;
            }
        } else if (unique) {
            this.listGrupo = []; // En las solicitudes de tipo PF, solo se puede incluir el grupo PF. Si no viene en la lista, la dejamos vacía.
        }
    }

    private guardRefreshPage(id: number): void {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    private removeValidationsPrevia(): void {
        this.removeValidators('NumeroDeclaracionSumaria');
    }

    private disableControlsConsulta(): void {
        this.form.controls['IdGrupo'].disable();
        this.form.controls['IdForma'].disable();
        this.form.controls['Partida'].disable();
        this.form.controls['CodigoTaric'].disable();
        this.form.controls['CodigoEppo'].disable();
        this.form.controls['NombreBotanico'].disable();
        this.form.controls['NombreComun'].disable();
        this.form.controls['Mrn'].disable();
        this.form.controls['IdPais'].disable();
        this.form.controls['Peso'].disable();
        this.form.controls['Volumen'].disable();
        this.form.controls['Unidades'].disable();
        this.form.controls['MarcasBulto'].disable();
        this.form.controls['NumeroBulto'].disable();
        this.form.controls['IdTipoBulto'].disable();
        this.form.controls['Nrc'].disable();
        this.form.controls['IdPaisReImportacion'].disable();
        //this.form.controls['EsOrganico'].disable();//RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
    }

    private createForm(): void {
        this.form = this.fb.group({
            IdPais: null,
            IdGrupo: [null, Validators.required],
            IdForma: [null, Validators.required],
            CodigoTaric: [null, Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10)])],
            Partida: [null, Validators.compose([Validators.required, Validators.maxLength(3), Validators.pattern('^[0-9]+([.,][0-9]+)?$')])],
            CodigoEppo: [null, Validators.required],
            NombreBotanico: [null, Validators.required],
            NombreComun: [null, Validators.required],
            Mrn: '',
            Peso: [0, Validators.compose([Validators.required, CustomValidator.DecimalTopCero])],
            Volumen: null,
            Unidades: null,
            NumeroDeclaracionSumaria: '',
            Nrc: '',
            MarcasBulto: '',
            NumeroBulto: null,
            IdTipoBulto: [null, Validators.required],
            PaisPredua: '',
            IdPaisReImportacion: null,
            //EsOrganico: false,//RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
        });
    }

    private updateForm(): void {
        this.form.setValue({
            IdPais: this.producto.IdPais,
            IdGrupo: this.producto.IdGrupo,
            IdForma: this.producto.IdForma,
            CodigoTaric: this.producto.CodigoTaric,
            Partida: this.producto.Partida,
            CodigoEppo: this.producto.CodigoEppo,
            NombreBotanico: this.producto.IdBotanicaDescripcion,
            NombreComun: this.producto.NombreComun,
            Mrn: this.producto.Mrn,
            Peso: this.decimalPipe.transform(this.producto.Peso, '1.3-3', 'es'),
            Volumen: this.decimalPipe.transform(this.producto.Volumen, '1.3-3', 'es'),
            Unidades: this.producto.Unidades,
            MarcasBulto: this.producto.MarcasBulto,
            NumeroBulto: this.producto.NumeroBulto,
            IdTipoBulto: this.producto.IdTipoBulto,
            NumeroDeclaracionSumaria: this.producto.DeclaracionSumaria,
            Nrc: this.producto.Nrc,
            PaisPredua: this.producto.IdPaisDescripcion,
            IdPaisReImportacion: this.producto.IdPaisReImportacion,
            //EsOrganico: this.producto.EsOrganico,//RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
        });
        this.IdEspecie = this.producto.IdEspecie;

        if (this.producto.EspecieSinEppo) {
            this.removeValidators('CodigoEppo');
            this.eppoObligatorio = false;
        } else {
            this.addValidator('CodigoEppo', Validators.required);
            this.eppoObligatorio = true;
        }
    }

    onSaveProducto(): void {
        this.onSubmit();
    }

    onSubmit(): void {
        this.visibilitySpinner = true;
        this.submitted = true;

        if (!this.form.valid) {
            this.visibilitySpinner = false;
            this.addErrorMessage('Revise los datos del producto');

            this.isCollapsedDatosBasicos = false;
            this.isCollapsedBulto = false;
            return;
        }

        const producto = this.createProductoFromForm();
        this.saveProducto(producto);
    }

    private createProductoFromForm(): TProductoSolicitudViewModel {
        const pesoFormat = this.form.value.Peso.replace('.', '').replace(',', '.');
        const volumenFormat = this.form.value.Volumen != null ? this.form.value.Volumen.replace('.', '').replace(',', '.') : this.form.value.Volumen;

        const producto = new TProductoSolicitudViewModel();

        producto.DeclaracionSumaria = this.isCanariasPifCanarias ? this.form.value.NumeroDeclaracionSumaria : null;
        producto.Mrn = this.form.value.Mrn;
        producto.Partida = this.form.value.Partida;
        producto.CodigoTaric = this.form.value.CodigoTaric;
        //producto.CodigoEppo = this.form.value.CodigoEppo; **hay q obtener el 'IdEspecie'
        producto.IdEspecie = this.IdEspecie;

        producto.NombreComun = this.form.value.NombreComun;
        producto.IdPais = this.form.value.IdPais != null ? this.form.value.IdPais : this.IdPaisOrigen;
        producto.MarcasBulto = this.form.value.MarcasBulto;
        producto.NumeroBulto = this.form.value.NumeroBulto;
        producto.IdTipoBulto = this.form.value.IdTipoBulto;
        producto.IdPaisReImportacion = this.form.value.IdPaisReImportacion;
        producto.Peso = pesoFormat;
        producto.Volumen = volumenFormat;
        producto.Unidades = this.form.value.Unidades;
        //producto.EsOrganico = this.form.value.EsOrganico;//RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
        producto.IdEnvioAduanas = 1; //PROVISIONAL PARA GUARDAR
        producto.IdEnvioFisico = 1; //PROVISIONAL PARA GUARDAR

        producto.IdSolicitud = this.IdSolicitud;
        producto.Id = this.producto.Id;

        return producto;
    }

    private saveProducto(productoSolicitud: TProductoSolicitudViewModel): void {
        if (this.editMode) {
            this.productoService
                .getSolicitudProductos(this.IdSolicitud)
                .pipe(
                    tap((resultSolicitudProductos: SolicitudProductosViewModel) => {
                        this.numeroProductos = resultSolicitudProductos.TProductoSolicitudCollection.length;

                        const ejecutarEdicion = (incompatible: boolean) => {
                            this.incompatible = incompatible;

                            if (this.producto.CodigoTaric !== this.form.value.CodigoTaric && this.numeroProductos === 1 && this.incompatible) {
                                this.confirmationService.confirm({
                                    message: '¿Está seguro? Si ha introducido datos en la sección "Importador | Lugar Destino" estos serán eliminados',
                                    accept: () => {
                                        this.productoService.editProducto(productoSolicitud).subscribe({
                                            next: () => {
                                                this.addSuccessMessage('Producto modificado correctamente');
                                                this.onBack();
                                                this.visibilitySpinner = false;
                                            },
                                            error: error => {
                                                this.catchServerError(error);
                                                if (error?.error?.length > 0) {
                                                    this.addErrorMessage(error.error[0]?.message);
                                                }
                                                this.visibilitySpinner = false;
                                                this.isCollapsedDatosBasicos = false;
                                                this.isCollapsedBulto = false;
                                            },
                                        });
                                    },
                                    reject: () => {
                                        this.visibilitySpinner = false;
                                    },
                                });
                            } else {
                                this.productoService.editProducto(productoSolicitud).subscribe({
                                    next: () => {
                                        this.addSuccessMessage('Producto modificado correctamente');
                                        this.onBack();
                                        this.visibilitySpinner = false;
                                    },
                                    error: error => {
                                        this.catchServerError(error);
                                        if (error?.error?.length > 0) {
                                            this.addErrorMessage(error.error[0]?.message);
                                        }
                                        this.visibilitySpinner = false;
                                        this.isCollapsedDatosBasicos = false;
                                        this.isCollapsedBulto = false;
                                    },
                                });
                            }
                        };

                        if (this.numeroProductos === 1) {
                            this.datosCompatibles.idConfiguracion = resultSolicitudProductos.TProductoSolicitudCollection[0].IdConfiguracion!;
                            this.datosCompatibles.CodigoTaric = productoSolicitud.CodigoTaric;
                            this.datosCompatibles.IdSolicitud = this.IdSolicitud;
                            this.productoService.isIncompatible(this.datosCompatibles).subscribe(res => {
                                ejecutarEdicion(res);
                            });
                        } else {
                            ejecutarEdicion(false);
                        }
                    }),
                    catchError(error => {
                        this.catchServerError(error);
                        return of([]);
                    }),
                )
                .subscribe();
        } else {
            this.productoService.createProducto(productoSolicitud).subscribe({
                next: () => {
                    this.addSuccessMessage('Producto creado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    if (error?.error?.length > 0) {
                        this.addErrorMessage(error.error[0]?.message);
                    }
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                    this.isCollapsedBulto = false;
                },
            });
        }
    }

    onAceptDialogPartidaPredua(partidaPredua: TPartidaPreduaViewModel): void {
        //this.infoPaisPartidaPredua = partidaPredua.PaisOrigen;
        this.form.patchValue({
            CodigoTaric: partidaPredua.CodigoTaric,
            Partida: partidaPredua.Partida,
            PaisPredua: partidaPredua.PaisOrigen,
        });

        this.IdPaisOrigen = partidaPredua.IdPaisOrigen;
        this.removeValidators('PaisPredua');
        this.esPaisCE = this.IdPaisOrigen == EnumIdsTcPais.ID_COMUNIDAD_EUROPEA ? true : false;
        if (this.esPaisCE) {
            this.addValidator('IdPaisReImportacion', Validators.required);
        } else {
            this.form.patchValue({
                IdPaisReImportacion: null,
            });
            this.removeValidators('IdPaisReImportacion');
        }
    }

    onAcceptDialogEspecieEppo(especieEppo: WBotanicaExtendedViewModel): void {
        //this.infoPaisPartidaPredua = partidaPredua.PaisOrigen;
        this.form.patchValue({
            CodigoEppo: especieEppo.CodigoEppo,
            NombreBotanico: especieEppo.IdNombreCientificoDescripcion,
            NombreComun: especieEppo.NombreComun,
        });

        this.IdEspecie = especieEppo.Id;
        //this.removeValidators("PaisPredua");
    }

    onSelectPais(): void {
        this.esPaisCE = this.form.value.IdPais == EnumIdsTcPais.ID_COMUNIDAD_EUROPEA ? true : false;
        if (this.esPaisCE) {
            this.addValidator('IdPaisReImportacion', Validators.required);
        } else {
            this.form.patchValue({
                IdPaisReImportacion: null,
            });
            this.removeValidators('IdPaisReImportacion');
        }
    }

    onSelectGrupo(): void {
        const idGrupo = this.form.value.IdGrupo;

        this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
            this.listForma = res;
        });

        this.form.patchValue({
            IdForma: null,
        });

        this.productoFitosanitarioFound = false;

        if (this.esPredua && idGrupo === EnumIdsTcGrupo.ID_PRODUCTOS_FITOSANITARIOS) {
            /**
             * Se validará (al guardar) que si la solicitud es de tipo predua y tiene más de un producto,
             * solo permita añadir uno de tipo fitosanitario.
             * Además, en éste caso la lista de productos solo podrá tener un producto.
             */
            this.productoFitosanitarioFound = true;
        }
    }

    onSelectForma(): void {
        this.IdForma = this.form.value.IdForma;

        let formaSeleccionada = this.listForma?.find(x => x.Id == this.IdForma);

        if (formaSeleccionada != null) {
            if ((<FormaViewModel>formaSeleccionada).EspecieSinEppo) {
                this.removeValidators('CodigoEppo');
                this.eppoObligatorio = false;
            } else {
                this.addValidator('CodigoEppo', Validators.required);
                this.eppoObligatorio = true;
            }
        }

        if (this.IdForma == null) {
            this.habilitarBusquedaEppo = false;
        } else {
            this.habilitarBusquedaEppo = true;
        }

        this.form.patchValue({
            CodigoEppo: '',
            NombreBotanico: '',
            NombreComun: '',
        });
    }

    onSearchCodigoTaric(): void {
        this.partidaPreduaPopupComponent.showDialog(this.partidas.ResultList);
    }

    onSearchCodigoEppo(): void {
        this.especieEppoPopupComponent.showDialog(this.form.controls['IdGrupo'].value, this.IdForma, null, false);
    }

    onBack(): void {
        //this.router.navigate(["/importacion/solicitud/productos", this.IdSolicitud])
        //Usamos el location ya que hay diferentes formas de llegar aquí­
        this._location.back();
    }
}
